import React from 'react';
import { Card } from '@leafwell/components';

const CardGradientHalf: React.FC<{
  className?: string;
  children: React.ReactChild | React.ReactChild[];
}> = ({ className = '', children }) => (
  <Card
    className={[
      'relative',
      'md:bg-none md:border-none',
      'before:-z-1 before:absolute before:md:w-1/2 before:h-full before:right-0 before:bottom-0 before:md:rounded-2xl before:md:bg-gradient-to-b before:from-lilac-100 before:to-green-300 before:gradient-mask-l-0',
      className,
    ].join(' ')}
    size="large"
    rounded
    filled
    variant="gradient"
  >
    {children}
  </Card>
);

export default CardGradientHalf;
